import { httpClient } from "../utils/httpClient";

export const sendTrackingEvent = async (
  trackingEvent: string,
  extra_attrs: Record<string, string | number> = {}
) => {
  await httpClient.post("/segment_analytics_actions/track", {
    event: trackingEvent,
    extra_attrs
  });
};

export const sendExternalTrackingEvent = async (
  trackingEvent: string,
  extra_attrs: Record<string, string | number> = {}
) => {
  await httpClient.post("/segment_analytics_actions/track_external", {
    event: trackingEvent,
    extra_attrs
  });
};

export const identifyUser = async () => {
  await httpClient.post("/segment_analytics_actions/identify");
};
